import { render, staticRenderFns } from "./ProductValue.vue?vue&type=template&id=e76b4ac6&scoped=true&"
import script from "./ProductValue.vue?vue&type=script&lang=js&"
export * from "./ProductValue.vue?vue&type=script&lang=js&"
import style0 from "./ProductValue.vue?vue&type=style&index=0&id=e76b4ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76b4ac6",
  null
  
)

export default component.exports